import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { errorToReason } from '../error-to-reason';
export var SwitcherLoadErrorReason = /*#__PURE__*/function (SwitcherLoadErrorReason) {
  SwitcherLoadErrorReason["AVAILABLE_PRODUCTS"] = "availableProducts";
  SwitcherLoadErrorReason["PRODUCT_CONFIGURATION"] = "productConfiguration";
  return SwitcherLoadErrorReason;
}({});
export var SwitcherLoadError = /*#__PURE__*/function (_Error) {
  _inherits(SwitcherLoadError, _Error);
  var _super = _createSuper(SwitcherLoadError);
  function SwitcherLoadError(errorReason, resultError) {
    var _this;
    _classCallCheck(this, SwitcherLoadError);
    _this = _super.call(this);
    _this.errorReason = errorReason;
    _this.resultError = resultError;
    return _this;
  }
  _createClass(SwitcherLoadError, [{
    key: "reason",
    value: function reason() {
      var potentialResultError = this.resultError;
      return _objectSpread(_objectSpread({}, errorToReason(potentialResultError.error ? potentialResultError.error : this.resultError)), {}, {
        source: this.errorReason
      });
    }
  }]);
  return SwitcherLoadError;
}( /*#__PURE__*/_wrapNativeSuper(Error));